module.exports = __webpack_public_path__ + "static/media/light_fixture_wall_led.0c6ed17a.png";